export type ChatbotAiKnowledgeSource = 'file' | 'text';
export type ChatbotAiKnowledgeModalMode = 'create' | 'file' | 'text';

export const CHATBOT_AI_KNOWLEDGE_CONFIG = {
  pageSize: 50,
  minChunkSize: 200,
  maxChunkSize: 2000,
  maxChunkOverlap: 500,
  defaultMaxChunkSize: 500,
  defaultChunkOverlap: 50,
} as const;

export const CHATBOT_AI_KNOWLEDGE_FILE_STATUS = {
  processed: 2,
  error: 3,
  processing: 4,
} as const;

export interface IChatbotAiKnowledge {
  id: string;
  name: string;
  businessId: number | string;
  type: number;
  platformId?: string | null;
  description: string;
  createdById: string;
  createdByName?: string;
  createdAt: number;
  fileCount?: number;
  textCount?: number;
  assistantCount?: number;
}

export interface IChatbotAiKnowledgeFile {
  id: string;
  name: string;
  businessId: number | string;
  type: number;
  status: number;
  fileName: string;
  size: number | string;
  url: string;
  knowledgeId: string;
  createdById: string;
  createdAt: number;
}

export interface IChatbotAiKnowledgeText {
  id: string;
  knowledgeId: string;
  title: string;
  text: string;
  embeddingIds: string[];
  createdById: string;
  createdAt: number;
}

export interface IChatbotAiKnowledgeCursorData<T> {
  result: T[];
  next: unknown[] | false;
}

export interface IChatbotAiKnowledgeListParams {
  size?: number;
  next?: string;
  ids?: string[];
}

export interface IChatbotAiKnowledgeContentListParams {
  knowledgeId?: string;
  size?: number;
  next?: string;
  title?: string;
}

export interface IChatbotAiKnowledgeTextParams {
  id?: string;
  title: string;
  text: string;
}

export interface IChatbotAiKnowledgeUpsertParams {
  knowledgeId?: string;
  knowledgeName?: string;
  knowledgeDescription?: string;
  maxChunkSize?: number;
  chunkOverlap?: number;
  knowledgeText?: IChatbotAiKnowledgeTextParams;
}

export interface IChatbotAiKnowledgeUpsertData {
  message: string;
  knowledge: IChatbotAiKnowledge;
  files: IChatbotAiKnowledgeFile[] | null;
  text: IChatbotAiKnowledgeText | null;
}

export interface IChatbotAiKnowledgeSaveFileEmbeddingParams {
  fileId: string;
  knowledgeId: string;
  url: string;
  chunk_size: number;
  overlap: number;
}

export interface IChatbotAiKnowledgeSaveFileEmbeddingData {
  message: string;
  fileId: string;
  errors: string[];
}

export interface IChatbotAiKnowledgeIdentityParams {
  id: string;
}

export interface IChatbotAiKnowledgeMessageData {
  message: string;
}
